import { SxProps, chipClasses, typographyClasses } from '@mui/material'
import { markerClasses, MARKER_TYPE, markerTypeClasses } from './Marker.data'

interface MarkerStyles {
  chip: SxProps
}

export const markerStyles: MarkerStyles = {
  chip: {
    zIndex: 0,
    typography: 'textXlMedium',
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    boxShadow: '0 4px 16px 0 rgba(0, 0, 0, 0.20)',

    [`.${chipClasses.icon}`]: {
      width: 20,
      height: 20,

      [`.${markerClasses.size.xs} &`]: {
        width: 14,
        height: 14,
      },
    },

    [`&.${chipClasses.colorDefault}.${markerTypeClasses[MARKER_TYPE.HOTEL_PRICE]}`]: {
      border: '2px solid',
      borderColor: 'border.brand',

      [`.${chipClasses.label}`]: {
        color: 'text.primary',
      },

      [`&.${markerClasses.active}`]: {
        backgroundColor: 'brand.primary600',

        [`.${chipClasses.label}`]: {
          color: 'text.primaryContrast',
        },
      },
    },

    [`&.${chipClasses.colorDefault}.${markerTypeClasses[MARKER_TYPE.VENUE]}`]: {
      backgroundColor: 'utils.gray950',

      [`.${chipClasses.icon}`]: {
        color: 'text.primaryContrast',
      },

      [`.${chipClasses.label}`]: {
        color: 'text.primaryContrast',
      },
    },

    [`&.${chipClasses.colorDefault}.${markerTypeClasses[MARKER_TYPE.CITY_CENTER]},
      &.${chipClasses.colorDefault}.${markerTypeClasses[MARKER_TYPE.AIRPORT]},
      &.${chipClasses.colorDefault}.${markerTypeClasses[MARKER_TYPE.HOTEL]},
      `]: {
      backgroundColor: 'background.default',

      [`.${chipClasses.icon}`]: {
        color: 'text.primary',
      },

      [`.${chipClasses.label}`]: {
        color: 'text.primary',
      },
    },

    [`&.${chipClasses.colorDefault}.${markerTypeClasses[MARKER_TYPE.CITY_CENTER]},
     &.${chipClasses.colorDefault}.${markerTypeClasses[MARKER_TYPE.AIRPORT]},
     &.${chipClasses.colorDefault}.${markerTypeClasses[MARKER_TYPE.VENUE]},
     &.${chipClasses.colorDefault}.${markerTypeClasses[MARKER_TYPE.HOTEL]}
     `]: {
      px: 0.5,

      [`.${chipClasses.label}`]: {
        [`.${typographyClasses.root}`]: {
          typography: 'textMdMedium',

          [`.${markerClasses.size.xs} &`]: {
            typography: 'textXsSemibold',
          },
        },
      },
    },
  },
}
